import React, { useState, useEffect } from "react";
import { CustomField } from "types";
import { showSuccess,showError } from "toast/toast";
type Props = {
    onSave: (fields: CustomField[]) => void;
    initialFields?: CustomField[];
};

const FIELD_TYPES = ["text", "file"] as const;

const CustomFieldBuilder: React.FC<Props> = ({ onSave, initialFields = [] }) => {
    const [fields, setFields] = useState<CustomField[]>(initialFields);
    // console.log("fields in CustomFieldBuilder", fields);


    const addField = () => {
        setFields([
            ...fields,
            { label: "", type: "text", required: false, id: Date.now() }
        ]);
    };

    const updateField = (id: number, key: keyof CustomField, value: any) => {
        setFields(fields?.map(field =>
            field.id === id ? { ...field, [key]: value } : field
        ));
    };

    const removeField = (id: number) => {
        setFields(fields?.filter(field => field.id !== id));
    };

    const saveFields = () => {
        onSave(fields);
        // console.log("fields", fields);
        showSuccess("Fields saved successfully");
    };

    useEffect(() => {
        if (initialFields && initialFields.length > 0) {
            setFields(initialFields);
        }
    }, [initialFields?.length]);

  return (
    <div className="">
      <div className="p-4 p-md-5">
        <h4 className="fw-semibold mb-3">Product Customization</h4>
        <div className="text-secondary mb-4">Customize Fields</div>

        {/* rows */}
        <div className="d-flex flex-column gap-3">
          {fields.map((field) => (
            <div
              key={field.id}
              className="pcb-row d-flex align-items-center gap-3 px-3 px-md-4 py-3 rounded-3 box-shadow-datatables br-8"
            >
              {/* Label */}
              <div className="flex-grow-1">
                <input
                  type="text"
                  className="form-control pcb-input"
                  placeholder="Label"
                  value={field.label}
                  onChange={(e) => updateField(field.id, "label", e.target.value)}
                />
              </div>

              {/* Type */}
              <div className="pcb-type">
                <div className="position-relative">
                  <select
                    className="form-select pcb-select"
                    value={field.type}
                    onChange={(e) => updateField(field.id, "type", e.target.value)}
                  >
                    {FIELD_TYPES.map((t) => (
                      <option key={t} value={t}>
                        {t}
                      </option>
                    ))}
                  </select>
                  <i className="ri-arrow-down-s-line pcb-caret" aria-hidden="true" />
                </div>
              </div>

              {/* Required */}
              <label className="d-flex align-items-center gap-2 mb-0 text-secondary pcb-required">
                <input
                  type="checkbox"
                  className="form-check-input m-0 pcb-check"
                  checked={field.required}
                  onChange={(e) => updateField(field.id, "required", e.target.checked)}
                />
                <span>Required</span>
              </label>

              {/* Delete */}
              <button
                type="button"
                className="btn btn-link p-0 ms-auto pcb-trash"
                onClick={() => removeField(field.id)}
                aria-label="Delete field"
                title="Delete"
              >
                <i className="ri-delete-bin-6-line" />
              </button>
            </div>
          ))}
        </div>

        {/* footer actions */}
        <div className="d-flex align-items-center gap-3 mt-4">
          <button type="button" className="btn pcb-add" onClick={addField}>
            <i className="ri-add-line me-2" />
            Add a customization field
          </button>

          <button type="button" className="btn btn-primary table-addbutton" onClick={saveFields}>
            Save Fields
          </button>
        </div>
      </div>

      {/* Scoped styles */}
      <style>{`
        .pcb .text-secondary { color: #6b7280 !important; }

        .pcb-row {
          background: #fff;
          border: 1px solid #eef0f3;
        }

        .pcb-input {
          height: 44px;
          background: #f5f7fb;
          border: 1px solid #e6e9ef;
          border-radius: 10px;
          padding: 10px 14px;
          color: #111827;
        }
        .pcb-input::placeholder { color: #9aa3af; }

        .pcb-type { width: 180px; min-width: 140px; }
        @media (max-width: 768px) {
          .pcb-type { width: 160px; }
        }

        .pcb-select {
          height: 44px;
          padding-right: 36px;
          background: #f5f7fb;
          border: 1px solid #e6e9ef;
          border-radius: 10px;
          appearance: none;
        }
        .pcb-caret {
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 20px;
          pointer-events: none;
          color: #6b7280;
        }

        .pcb-required { min-width: 120px; }
        .pcb-check { width: 18px; height: 18px; border-radius: 6px; }

        .pcb-trash {
          color: #a1a1aa;
          font-size: 20px;
        }
        .pcb-trash:hover { color: #ef4444; }

        .pcb-add {
          background: #ffffff;
          border: 1px solid #e6e9ef;
          color: #111827;
        }
        .pcb-add i { font-size: 18px; vertical-align: -2px; }

        .pcb-save {
          padding-left: 18px; padding-right: 18px;
          box-shadow: 0 1px 2px rgba(16,24,40,.05);
        }
      `}</style>
    </div>
  );

    // return (
    //     <div>
    //         <h3>Customize Fields</h3>
    //         {fields?.map(field => (
    //             <div key={field.id} style={{ gap: "1rem", marginBottom: "1rem" }}>
    //                 <div className="row align-items-center g-2 mb-2" id="row-overlap">
    //                     {/* Label Input */}
    //                     <div className="col-md-2" style={{paddingLeft: "0px"}}>
    //                         <input
    //                             type="text"
    //                             placeholder="Label"
    //                             value={field.label}
    //                             onChange={(e) => updateField(field.id, "label", e.target.value)}
    //                             className="form-control"
    //                         />
    //                     </div>

    //                     {/* Type Selector */}
    //                     <div className="col-md-1">
    //                         <select
    //                             value={field.type}
    //                             onChange={(e) => updateField(field.id, "type", e.target.value)}
    //                             className="form-select"
    //                         >
    //                             {FIELD_TYPES?.map((type) => (
    //                                 <option key={type} value={type}>
    //                                     {type}
    //                                 </option>
    //                             ))}
    //                         </select>
    //                     </div>

    //                     {/* Required Checkbox */}
    //                     <div className="col-md-1 d-flex align-items-center">
    //                         <input
    //                             type="checkbox"
    //                             checked={field.required}
    //                             onChange={(e) => updateField(field.id, "required", e.target.checked)}
    //                             className="form-check-input me-2"
    //                             id={`required-${field.id}`}
    //                         />
    //                         <label htmlFor={`required-${field.id}`} className="form-check-label">
    //                             Required
    //                         </label>
    //                     </div>

    //                     {/* Delete Button */}
    //                     <div className="col-md-2">
    //                         <button
    //                             className="btn btn-light btn-sm rounded-circle shadow-sm"
    //                             onClick={() => removeField(field.id)}
    //                         >
    //                             <i className="ri-delete-bin-line text-danger fs-18"></i>
    //                         </button>
    //                     </div>
    //                 </div>

    //                 {/* <div className="row">
    //                     <div className="col-md-3 pt-1">
    //                         <input
    //                             type="text"
    //                             placeholder="Label"
    //                             value={field.label}
    //                             onChange={(e) => updateField(field.id, "label", e.target.value)}
    //                             className="form-control"
    //                         />
    //                     </div>
    //                     <div className="col-md-1">
    //                         <select
    //                             value={field.type}
    //                             onChange={(e) => updateField(field.id, "type", e.target.value)}
    //                             className="form-control"
    //                         >
    //                             {FIELD_TYPES?.map(type => (
    //                                 <option key={type} value={type}>{type}</option>
    //                             ))}
    //                         </select>
    //                     </div>
    //                     <div className="col-md-1 p-3">
    //                         <label>
    //                             <input
    //                                 type="checkbox"
    //                                 checked={field.required}
    //                                 onChange={(e) => updateField(field.id, "required", e.target.checked)}
    //                             />
    //                             {" "} Required
    //                         </label>
    //                     </div>
    //                     <div className="col-md-1">
    //                         <button className="btn btn-light btn-sm rounded-circle shadow-sm" onClick={() => removeField(field.id)}> <i className="ri-delete-bin-line text-danger fs-18"></i></button>
    //                     </div>
    //                 </div> */}
    //             </div>
    //         ))}
    //         <div className="btn btn-outline-dark" onClick={addField}>Add a customization field</div>
    //         <br />
    //         <div className="btn btn-info mt-4" onClick={saveFields}>Save Fields</div>
    //     </div>
    // );
};

export default CustomFieldBuilder;
